// NOTE:
// In order to use the api endpoints (locally) as specified below, cross-origin restrictions
// need to be disabled in browser and the cumberland drupal site must be reachable
// at https://dev-54ta5gq-r5fuqqu6dbgis.au.platformsh.site by your web browser

const host =
    process.env.NODE_ENV === "development"
        ? "https://dev-54ta5gq-r5fuqqu6dbgis.au.platformsh.site"
        : "";

export default {
    fetchTimeout: 20000,
    tokenAPI: `${host}/session/token`,
    newsletterAPI: `${host}/api/constant-contact`,
    datepickerAPI: `${host}/api/events/dates`,
    searchAutoSuggestionAPI: `${host}${
        window.globalData ? window.globalData.search.autocomplete.url : ""
    }`,
    googleMapsKey: "AIzaSyBI9py01-X7bFiEG2S2T0TH3RHSb-ob2L4",
    frontendDateFormat: "DD/MM/YYYY", // What is shown to users
    backendDateFormat: "YYYY-MM-DD", // What is sent to the server
};
